// src/modules/locais/index.jsx
import React, { useState, useEffect } from "react";
import env from "../../config/env.js";
import {
  Box, Button, Dialog, DialogActions, DialogContent, DialogTitle,
  IconButton, Paper, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, TextField, Typography, TableSortLabel,
  Tooltip, Switch, FormControlLabel, MenuItem,
  Snackbar, Alert, TablePagination, Tabs, Tab,
  CircularProgress
  // useTheme // Removido - não utilizado
} from "@mui/material";
import {
  Add as AddIcon,
  Delete as DeleteIcon,
  Edit as EditIcon,
  Visibility as VisibilityIcon,
  ThumbUp,
  ThumbDown,
  // Close as CloseIcon, // Removido - não utilizado
  LocationOn as LocationOnIcon
} from "@mui/icons-material";

import api from "../../services/api";
import { 
  formatarTelefone,
  formatarCEP,
  createApiErrorMessage,
  createValidationMessage,
  createCrudMessage
} from "../../utils/formatadores";
import AcessoRestrito from '../../components/AcessoRestrito';


export default function Locais() {
  const [locais, setLocais] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filtros, setFiltros] = useState({
    nome: '',
    tipo: '',
    capacidade: '',
    cidade: '',
    status: ''
  });
  const [orderBy, setOrderBy] = useState("nome");
  const [order, setOrder] = useState("asc");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [openForm, setOpenForm] = useState(false);
  const [openView, setOpenView] = useState(false);
  const [localSelecionado, setLocalSelecionado] = useState(null);
  const [formData, setFormData] = useState({
    nome: '',
    tipo: '',
    capacidade: '',
    descricao: '',
    andar: '',
    bloco: '',
    ativo: true,
    cep: '',
    endereco: '',
    cidade: '',
    estado: '',
    telefone: '',
    email: '',
    equipamentosMedicos: [],
    especialidadesAtendidas: []
  });
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [activeTabForm, setActiveTabForm] = useState(0);
  const [activeTabView, setActiveTabView] = useState(0);
  const [dataHoraAtual, setDataHoraAtual] = useState(new Date());
  const [formErrors, setFormErrors] = useState({
    nome: false,
    tipo: false,
    capacidade: false
  });
  const [localVisualizar, setLocalVisualizar] = useState(null);
  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
  const [localParaExcluir, setLocalParaExcluir] = useState(null);

  const token = localStorage.getItem("token");
  const codHashEmpresa = localStorage.getItem("st_codHashEmpresa");

  const validarFormulario = React.useCallback(() => {
    const novosErros = {
      nome: !formData.nome?.trim(),
      tipo: !formData.tipo,
      capacidade: !formData.capacidade || formData.capacidade < 1
    };

    setFormErrors(novosErros);
    return !Object.values(novosErros).some(erro => erro);
  }, [formData]);

  // Função para carregar locais
  const carregarLocais = React.useCallback(async () => {
    if (!token) {
      setError(createApiErrorMessage({ response: { status: 401 } }, 'Autenticação'));
      return;
    }
    try {
      setLoading(true);
      const res = await api.get(`/local?st_codHashEmpresa=${codHashEmpresa}`);
      
      // Garantir que seja sempre um array
      const dadosLocais = Array.isArray(res.data) ? res.data : [];
      
      setLocais(dadosLocais);
    } catch (error) {
      setError(createApiErrorMessage(error, 'Carregar locais'));
      console.error("Erro ao carregar locais:", error);
      setLocais([]); // Garantir que seja um array vazio em caso de erro
    } finally {
      setLoading(false);
    }
  }, [token, codHashEmpresa]);

  useEffect(() => {
    if (token) {
      carregarLocais();
    }
  }, [token, carregarLocais]);

  useEffect(() => {
    const timer = setInterval(() => {
      setDataHoraAtual(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const abrirFormulario = React.useCallback((local = null) => {
    setLocalSelecionado(local);
    setFormData({
      nome: local?.nome || '',
      tipo: local?.tipo || '',
      capacidade: local?.capacidade || '',
      descricao: local?.descricao || '',
      andar: local?.andar || '',
      bloco: local?.bloco || '',
      ativo: local?.ativo || true,
      cep: local?.cep || '',
      endereco: local?.endereco || '',
      cidade: local?.cidade || '',
      estado: local?.estado || '',
      telefone: local?.telefone || '',
      email: local?.email || '',
      equipamentosMedicos: local?.equipamentosMedicos || [],
      especialidadesAtendidas: local?.especialidadesAtendidas || []
    });
    setActiveTabForm(0);
    setOpenForm(true);
  }, []);

  const visualizarLocal = React.useCallback(async (id) => {
    if (!token) {
      setError(createApiErrorMessage({ response: { status: 401 } }, 'Autenticação'));
      return;
    }

    try {
      const res = await api.get(`/local/${id}?st_codHashEmpresa=${codHashEmpresa}`);
      setLocalVisualizar(res.data);
      setActiveTabView(0);
      setOpenView(true);
    } catch (error) {
      setError(createApiErrorMessage(error, 'Buscar local'));
      console.error("Erro ao buscar local:", error);
    }
  }, [token, codHashEmpresa]);

  const fecharVisualizacao = React.useCallback(() => {
    setOpenView(false);
    setLocalVisualizar(null);
    setActiveTabView(0);
  }, []);

  const fecharFormulario = React.useCallback(() => {
    setOpenForm(false);
    setLocalSelecionado(null);
    setFormData({
      nome: '',
      tipo: '',
      capacidade: '',
      descricao: '',
      andar: '',
      bloco: '',
      ativo: true,
      cep: '',
      endereco: '',
      cidade: '',
      estado: '',
      telefone: '',
      email: '',
      equipamentosMedicos: [],
      especialidadesAtendidas: []
    });
    setActiveTabForm(0);
  }, []);

  // Função para validação em tempo real (onBlur)
  const handleBlur = React.useCallback((event) => {
    const { name, value } = event.target;
    
    // Validação específica por campo
    switch (name) {
      case 'nome':
        if (!value || value.trim().length === 0) {
          setFormErrors(prev => ({
            ...prev,
            nome: true
          }));
        } else {
          setFormErrors(prev => ({
            ...prev,
            nome: false
          }));
        }
        break;
        
      case 'tipo':
        if (!value || value.trim().length === 0) {
          setFormErrors(prev => ({
            ...prev,
            tipo: true
          }));
        } else {
          setFormErrors(prev => ({
            ...prev,
            tipo: false
          }));
        }
        break;
        
      case 'endereco':
        if (!value || value.trim().length === 0) {
          setFormErrors(prev => ({
            ...prev,
            endereco: true
          }));
        } else {
          setFormErrors(prev => ({
            ...prev,
            endereco: false
          }));
        }
        break;
        
      default:
        break;
    }
  }, []);

  const handleInputChange = React.useCallback((event) => {
    const { name, value } = event.target;
    let valorFormatado = value;

    // Aplica a formatação apropriada usando as funções padrão do sistema
    if (name === 'telefone') {
      valorFormatado = formatarTelefone(value);
    } else if (name === 'cep') {
      valorFormatado = formatarCEP(value);
    }

    setFormData(prev => ({
      ...prev,
      [name]: valorFormatado
    }));

    // Limpa o erro do campo quando ele é alterado
    if (formErrors[name]) {
      setFormErrors(prev => ({
        ...prev,
        [name]: false
      }));
    }

    // Lookup de CEP (ViaCEP) quando atingir 8 dígitos numéricos
    if (name === 'cep') {
      const cepNumeros = valorFormatado.replace(/\D/g, '');
      if (cepNumeros.length === 8) {
        fetch(`https://viacep.com.br/ws/${cepNumeros}/json/`)
          .then(res => res.json())
          .then(dados => {
            if (dados && !dados.erro) {
              setFormData(prev => ({
                ...prev,
                endereco: dados.logradouro || prev.endereco || '',
                cidade: dados.localidade || prev.cidade || '',
                estado: dados.uf || prev.estado || ''
              }));
            }
          })
          .catch(() => {
            // Silencioso: não bloquear fluxo em caso de falha do CEP
          });
      }
    }
  }, [formErrors]);

  const locaisFiltrados = React.useMemo(() => {
    if (!Array.isArray(locais) || locais.length === 0) {
      return [];
    }
    
    return locais.filter(local => {
      if (!local) return false;
      
      return (
        (local.nome || '').toLowerCase().includes(filtros.nome.toLowerCase()) &&
        (local.tipo || '').toLowerCase().includes(filtros.tipo.toLowerCase()) &&
        (local.capacidade || '').toString().includes(filtros.capacidade) &&
        (local.cidade || '').toLowerCase().includes(filtros.cidade.toLowerCase()) &&
        (filtros.status === '' || (filtros.status === 'Ativo' ? local.ativo : !local.ativo))
      );
    });
  }, [locais, filtros]);

  const locaisOrdenados = React.useMemo(() => {
    return locaisFiltrados.sort((a, b) => {
      if (!a || !b) return 0;
      
      const isAsc = order === "asc";
      if (orderBy === "nome") {
        return isAsc ? (a.nome || "").localeCompare(b.nome || "") : (b.nome || "").localeCompare(a.nome || "");
      } else if (orderBy === "tipo") {
        return isAsc ? (a.tipo || "").localeCompare(b.tipo || "") : (b.tipo || "").localeCompare(a.tipo || "");
      } else if (orderBy === "capacidade") {
        return isAsc ? (a.capacidade || 0) - (b.capacidade || 0) : (b.capacidade || 0) - (a.capacidade || 0);
      } else if (orderBy === "cidade") {
        return isAsc ? (a.cidade || "").localeCompare(b.cidade || "") : (b.cidade || "").localeCompare(a.cidade || "");
      } else if (orderBy === "ativo") {
        return isAsc ? (a.ativo === b.ativo ? 0 : a.ativo ? -1 : 1) : (a.ativo === b.ativo ? 0 : a.ativo ? 1 : -1);
      }
      return 0;
    });
  }, [locaisFiltrados, order, orderBy]);

  const locaisPaginados = React.useMemo(() => {
    return locaisOrdenados.slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage
    );
  }, [locaisOrdenados, page, rowsPerPage]);

  const handleFiltroChange = React.useCallback((event) => {
    const { name, value } = event.target;
    setFiltros(prev => ({
      ...prev,
      [name]: value
    }));
    setPage(0);
  }, []);

  const handleRequestSort = React.useCallback((property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  }, [order, orderBy]);

  const handleChangePage = React.useCallback((event, newPage) => {
    setPage(newPage);
  }, []);

  const handleChangeRowsPerPage = React.useCallback((event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  }, []);

  const handleTabChange = React.useCallback((event, newValue) => {
    setActiveTabForm(newValue);
  }, []);

  const formatarDataHora = React.useCallback((data) => {
    return new Date(data).toLocaleString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  }, []);

  const salvarLocal = React.useCallback(async () => {
    if (!token) {
      setError(createApiErrorMessage({ response: { status: 401 } }, 'Autenticação'));
      return;
    }

    if (!validarFormulario()) {
      setError(createValidationMessage('formulario', 'required'));
      return;
    }

    try {
      setLoading(true);

      const dadosFormatados = {
        nome: formData.nome?.trim(),
        tipo: formData.tipo,
        capacidade: parseInt(formData.capacidade),
        descricao: formData.descricao?.trim(),
        andar: formData.andar?.trim(),
        bloco: formData.bloco?.trim(),
        ativo: formData.ativo,
        cep: formData.cep?.replace(/\D/g, ''),
        endereco: formData.endereco?.trim(),
        cidade: formData.cidade?.trim(),
        estado: formData.estado?.trim(),
        telefone: formData.telefone?.replace(/\D/g, ''),
        email: formData.email?.trim(),
        equipamentosMedicos: formData.equipamentosMedicos || [],
        especialidadesAtendidas: formData.especialidadesAtendidas || [],
        st_codHashEmpresa: codHashEmpresa
      };

      if (localSelecionado) {
        await api.put(
          `/local/${localSelecionado.id}?st_codHashEmpresa=${codHashEmpresa}`,
          dadosFormatados
        );
        
        setSuccess(createCrudMessage('update', 'Local', true));
      } else {
        await api.post(
          `/local`,
          dadosFormatados
        );
        
        setSuccess(createCrudMessage('create', 'Local', true));
      }

      await carregarLocais();
      fecharFormulario();
      
      // Limpar filtros após salvar com sucesso
      setFiltros({
        nome: '',
        tipo: '',
        capacidade: '',
        cidade: '',
        status: ''
      });
      setPage(0); // Resetar para primeira página
    } catch (error) {
      console.error('=== ERRO DETALHADO ===');
      console.error('Mensagem de erro:', error.message);
      console.error('Resposta do servidor:', error.response?.data);
      console.error('Status do erro:', error.response?.status);
      console.error('Headers da requisição:', error.config?.headers);
      console.error('URL da requisição:', error.config?.url);
      console.error('Método da requisição:', error.config?.method);
      console.error('Dados enviados:', error.config?.data);
      
      setError(createApiErrorMessage(error, 'Salvar local'));
    } finally {
      setLoading(false);
    }
  }, [token, codHashEmpresa, formData, localSelecionado, validarFormulario, carregarLocais, fecharFormulario]);

  const excluirLocal = React.useCallback(async () => {
    if (!token) {
      setError(createApiErrorMessage({ response: { status: 401 } }, 'Autenticação'));
      return;
    }

    try {
      setLoading(true);
      await api.delete(
        `/local/${localParaExcluir.id}?st_codHashEmpresa=${codHashEmpresa}`
      );
      setSuccess(createCrudMessage('delete', 'Local', true));
      setOpenDeleteConfirm(false);
      setLocalParaExcluir(null);
      await carregarLocais();
      
      // Limpar filtros após excluir com sucesso
      setFiltros({
        nome: '',
        tipo: '',
        capacidade: '',
        cidade: '',
        status: ''
      });
      setPage(0); // Resetar para primeira página
    } catch (error) {
      setError(createApiErrorMessage(error, 'Excluir local'));
      console.error("Erro ao excluir local:", error);
    } finally {
      setLoading(false);
    }
  }, [token, codHashEmpresa, localParaExcluir, carregarLocais]);

  return (
    <AcessoRestrito modulo="locais">
      <Box
        sx={{
          height: '100%',
          width: '100%',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
      <Snackbar 
        open={!!error} 
        autoHideDuration={env.NOTIFICATION_DURATION || 6000} 
        onClose={() => setError(null)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setError(null)} severity="error" sx={{ width: '100%' }}>
          {error}
        </Alert>
        </Snackbar>

      <Snackbar 
        open={!!success} 
        autoHideDuration={env.NOTIFICATION_DURATION || 6000} 
        onClose={() => setSuccess(null)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setSuccess(null)} severity="success" sx={{ width: '100%' }}>
          {success}
        </Alert>
        </Snackbar>

        {/* Box interno com margens de 1,5% */}
        <Box sx={{
          margin: '0 1.5% 1.5% 1.5%',  // 1,5% nas laterais e inferior
          height: '90vh',
          display: 'flex',
          flexDirection: 'column'
        }}>
          <Box sx={{ 
            p: { xs: 2, sm: 3 }, 
            pb: 2,
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: { xs: 'flex-start', sm: 'center' },
            flexDirection: { xs: 'column', sm: 'row' },
            gap: { xs: 2, sm: 0 }
          }}>
            <Typography 
              variant="h5" 
              mb={1} 
              sx={{ 
                fontSize: { xs: '1.5rem', sm: '2rem' },
                display: 'flex',
                alignItems: 'center',
                gap: 1
              }}
            >
              <LocationOnIcon sx={{ 
                fontSize: { xs: '1.5rem', sm: '2rem' },
                color: '#FFC107' // Mesma cor usada no menu lateral
              }} />
              Locais
            </Typography>
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
              <Button 
                variant="contained" 
                onClick={() => abrirFormulario()}
                sx={{
                  width: { xs: '100%', sm: 'auto' },
                  minWidth: { xs: 'auto', sm: '200px' },
                  backgroundColor: (theme) => theme.palette.mode === 'dark'
                    ? '#ffffff'
                    : theme.palette.primary.main,
                  color: (theme) => theme.palette.mode === 'dark'
                    ? '#000000'
                    : theme.palette.primary.contrastText,
                  '&:hover': {
                    backgroundColor: (theme) => theme.palette.mode === 'dark'
                      ? '#f5f5f5'
                      : theme.palette.primary.dark,
                  }
                }}
              >
                <AddIcon /> Novo Local
              </Button>
            </Box>
          </Box>

          {/* Container da Tabela */}
          <TableContainer
            component={Paper}
            sx={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              position: 'relative',
              overflow: 'auto',
              height: {
                xs: 'calc(90vh - 140px)',
                sm: 'calc(90vh - 120px)',
                md: 'calc(90vh - 120px)',
                lg: 'calc(90vh - 120px)'
              },
              maxHeight: {
                xs: 'calc(90vh - 140px)',
                sm: 'calc(90vh - 120px)',
                md: 'calc(90vh - 120px)',
                lg: 'calc(90vh - 120px)'
              },
              width: '100%',
              minWidth: { xs: '100%', sm: '600px' },
              maxWidth: '100%',
              boxShadow: (theme) => theme.palette.mode === 'dark' ? '0 2px 8px rgba(0, 0, 0, 0.15)' : '0 2px 8px rgba(0, 0, 0, 0.06)',
              borderRadius: 2,
              border: 'none'
            }}
          >
          <Table sx={{ 
            minWidth: { xs: 800, sm: 650 }, 
            tableLayout: 'fixed',
            width: '100%'
          }}>
            <TableHead sx={{
              position: 'sticky',
              top: 0,
              zIndex: 10,
              backgroundColor: (theme) => theme.palette.background.paper,
              '& .MuiTableCell-root': {
                backgroundColor: (theme) => theme.palette.background.paper,
                borderBottom: 2,
                borderBottomColor: 'divider'
              }
            }}>
              <TableRow>
                <TableCell sx={{ 
                  width: { xs: '20%', sm: '20%' },
                  minWidth: { xs: '120px', sm: '120px' }
                }}>
                  <TableSortLabel
                    active={orderBy === "nome"}
                    direction={orderBy === "nome" ? order : "asc"}
                    onClick={() => handleRequestSort("nome")}
                  >
                    Nome
                  </TableSortLabel>
                  <TextField
                    name="nome"
                    size="small"
                    fullWidth
                    value={filtros.nome}
                    onChange={handleFiltroChange}
                    placeholder="Filtrar por nome"
                    sx={{ 
                      '& .MuiInputBase-input': {
                        fontSize: { xs: '0.75rem', sm: '0.875rem' }
                      }
                    }}
                  />
                </TableCell>
                <TableCell sx={{ 
                  width: { xs: '20%', sm: '20%' },
                  minWidth: { xs: '100px', sm: '100px' }
                }}>
                  <TableSortLabel
                    active={orderBy === "tipo"}
                    direction={orderBy === "tipo" ? order : "asc"}
                    onClick={() => handleRequestSort("tipo")}
                  >
                    Tipo
                  </TableSortLabel>
                  <TextField
                    name="tipo"
                    size="small"
                    fullWidth
                    value={filtros.tipo}
                    onChange={handleFiltroChange}
                    placeholder="Filtrar por tipo"
                    sx={{ 
                      '& .MuiInputBase-input': {
                        fontSize: { xs: '0.75rem', sm: '0.875rem' }
                      }
                    }}
                  />
                </TableCell>
                <TableCell sx={{ 
                  width: { xs: '15%', sm: '15%' },
                  minWidth: { xs: '100px', sm: '100px' }
                }}>
                  <TableSortLabel
                    active={orderBy === "capacidade"}
                    direction={orderBy === "capacidade" ? order : "asc"}
                    onClick={() => handleRequestSort("capacidade")}
                  >
                    Capacidade
                  </TableSortLabel>
                  <TextField
                    name="capacidade"
                    size="small"
                    fullWidth
                    value={filtros.capacidade}
                    onChange={handleFiltroChange}
                    placeholder="Filtrar por capacidade"
                    sx={{ 
                      '& .MuiInputBase-input': {
                        fontSize: { xs: '0.75rem', sm: '0.875rem' }
                      }
                    }}
                  />
                </TableCell>
                <TableCell sx={{ 
                  width: { xs: '20%', sm: '15%' },
                  minWidth: { xs: '100px', sm: '100px' }
                }}>
                  <TableSortLabel
                  active={orderBy === "cidade"}
                  direction={orderBy === "cidade" ? order : "asc"}
                  onClick={() => handleRequestSort("cidade")}
                  >
                  Cidade
                  </TableSortLabel>
                  <TextField
                    name="cidade"
                    size="small"
                    fullWidth
                    value={filtros.cidade}
                    onChange={handleFiltroChange}
                    placeholder="Filtrar por cidade"
                    sx={{ 
                      '& .MuiInputBase-input': {
                        fontSize: { xs: '0.75rem', sm: '0.875rem' }
                      }
                    }}
                  />
                </TableCell>
                <TableCell sx={{ 
                  width: { xs: '10%', sm: '10%' },
                  minWidth: { xs: '60px', sm: '60px' }
                }}>
                  <TableSortLabel
                    active={orderBy === "ativo"}
                    direction={orderBy === "ativo" ? order : "asc"}
                    onClick={() => handleRequestSort("ativo")}
                  >
                    Status
                  </TableSortLabel>
                </TableCell>
                <TableCell sx={{ 
                  width: { xs: '15%', sm: '20%' },
                  minWidth: { xs: '100px', sm: '100px' },
                  textAlign: 'right' // ✅ Alinha o título à direita
                }}>
                  Ações
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                <TableCell colSpan={6} align="center">
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              ) : locaisPaginados.length === 0 ? (
                <TableRow>
                <TableCell colSpan={6} align="center">
                    Nenhum local encontrado.
                  </TableCell>
                </TableRow>
              ) : (
                locaisPaginados.map((local, index) => (
                  <TableRow 
                    key={local.id}
                    sx={{
                      backgroundColor: (theme) => 
                        index % 2 === 0 
                          ? theme.palette.mode === 'dark' 
                            ? 'rgba(255, 255, 255, 0.02)' 
                            : 'rgba(0, 0, 0, 0.02)'
                          : 'transparent',
                      '&:hover': {
                        backgroundColor: (theme) => theme.palette.mode === 'dark' 
                          ? 'rgba(255, 255, 255, 0.08)' 
                          : 'rgba(0, 0, 0, 0.08)',
                      }
                    }}
                  >
                  <TableCell sx={{ 
                    overflow: 'hidden', 
                    textOverflow: 'ellipsis', 
                    whiteSpace: 'nowrap', 
                    lineHeight: 1.2,
                    fontSize: { xs: '0.75rem', sm: '0.875rem' }
                  }}>
                    {local.nome}
                  </TableCell>
                  <TableCell sx={{ 
                    overflow: 'hidden', 
                    textOverflow: 'ellipsis', 
                    whiteSpace: 'nowrap', 
                    lineHeight: 1.2,
                    fontSize: { xs: '0.75rem', sm: '0.875rem' }
                  }}>
                    {local.tipo}
                  </TableCell>
                  <TableCell sx={{ 
                    overflow: 'hidden', 
                    textOverflow: 'ellipsis', 
                    whiteSpace: 'nowrap', 
                    lineHeight: 1.2,
                    fontSize: { xs: '0.75rem', sm: '0.875rem' }
                  }}>
                    {local.capacidade}
                  </TableCell>
                  <TableCell sx={{ 
                    overflow: 'hidden', 
                    textOverflow: 'ellipsis', 
                    whiteSpace: 'nowrap', 
                    lineHeight: 1.2,
                    fontSize: { xs: '0.75rem', sm: '0.875rem' }
                  }}>
                    {local.cidade || ''}
                  </TableCell>
                  <TableCell>
                    <Tooltip title={local.ativo ? "Ativo" : "Inativo"}>
                      {local.ativo ? (
                        <ThumbUp className="material-icon-status-active" />
                      ) : (
                        <ThumbDown className="material-icon-status-inactive" />
                      )}
                    </Tooltip>
                  </TableCell>
                    <TableCell sx={{ 
                      textAlign: 'right', // ✅ Alinha o conteúdo à direita
                      paddingRight: 3, // ✅ Adiciona padding à direita
                      fontSize: { xs: '0.75rem', sm: '0.875rem' }
                    }}>
                    <Box sx={{ 
                      display: 'flex', 
                      gap: { xs: 0.5, sm: 1 },
                      flexWrap: 'wrap',
                      justifyContent: 'flex-end' // ✅ Alinha os botões à direita
                    }}>
                      <Tooltip title="Visualizar">
                        <IconButton 
                          size="small" 
                          onClick={() => visualizarLocal(local.id)}
                          sx={{ 
                            padding: { xs: '4px', sm: '8px' }
                          }}
                        >
                          <VisibilityIcon 
                            fontSize="small" 
                            className="material-icon-visibility"
                            sx={{ 
                              fontSize: { xs: '1rem', sm: '1.25rem' }
                            }}
                          />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Editar">
                        <IconButton 
                          size="small" 
                          onClick={() => abrirFormulario(local)}
                          sx={{ 
                            padding: { xs: '4px', sm: '8px' }
                          }}
                        >
                          <EditIcon 
                            fontSize="small" 
                            className="material-icon-edit"
                            sx={{ 
                              fontSize: { xs: '1rem', sm: '1.25rem' }
                            }}
                          />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Excluir">
                        <IconButton 
                          size="small" 
                          onClick={() => { setLocalParaExcluir(local); setOpenDeleteConfirm(true); }}
                          sx={{ 
                            padding: { xs: '4px', sm: '8px' }
                          }}
                        >
                          <DeleteIcon 
                            fontSize="small" 
                            className="material-icon-delete"
                            sx={{ 
                              fontSize: { xs: '1rem', sm: '1.25rem' }
                            }}
                          />
                        </IconButton>
                      </Tooltip>
                    </Box>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

          {/* Paginação fora do TableContainer */}
          <TablePagination
            component="div"
            count={locaisFiltrados.length}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[5, 10, 25]}
            labelRowsPerPage="Itens por página"
            labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
            sx={{
              backgroundColor: (theme) => theme.palette.background.default,
              borderTop: 'none',
              width: '100%',
              marginTop: 0
            }}
          />
        </Box> {/* Fechamento do Box interno com margens */}

      <Dialog
        open={openForm}
        onClose={fecharFormulario}
        maxWidth={false}
        fullWidth={false}
        disableEscapeKeyDown
        disableBackdropClick
        disablePortal
        hideBackdrop={false}
        sx={{
          '& .MuiDialog-backdrop': {
            backgroundColor: 'rgba(0, 0, 0, 0.8)'
          }
        }}
        PaperProps={{
          sx: {
            width: '950px',
            height: '600px',
            position: 'relative'
          }
        }}
      >
        <DialogTitle sx={{ 
          backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1B5E20' : '#E0F8E0',
          borderBottom: 1,
          borderColor: 'divider',
          padding: 2,
          position: 'sticky',
          top: 0,
          zIndex: 1,
          fontSize: '1.25rem',
          fontWeight: 500
        }}>
          {localSelecionado ? "Editar Local" : "Novo Local"}
        </DialogTitle>

        <DialogContent sx={{ 
          height: 'calc(100% - 140px)',
          overflow: 'auto',
          padding: 2,
          position: 'relative',
          top: 0,
          marginBottom: '60px',
          '& .MuiInputLabel-root': {
            fontSize: '0.875rem'
          },
          '& .MuiInputBase-input': {
            fontSize: '0.875rem'
          },
          '& .MuiFormControlLabel-label': {
            fontSize: '0.875rem'
          }
        }}>
          <Tabs 
            value={activeTabForm} 
            onChange={handleTabChange}
            sx={{
              borderBottom: 1,
              borderColor: 'divider',
              mb: 2
            }}
          >
            <Tab label="Dados Básicos" />
            <Tab label="Endereço" />
            <Tab label="Contato" />
            <Tab label="Especificações" />
          </Tabs>

          {activeTabForm === 0 && (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <TextField 
                fullWidth 
                label="Nome" 
                name="nome" 
                value={formData.nome} 
                onChange={handleInputChange}
                required
                error={formErrors.nome}
                helperText={formErrors.nome ? "Nome é obrigatório" : ""}
              />
              <Box sx={{ display: 'flex', gap: 2 }}>
                <TextField
                  fullWidth
                  label="Tipo"
                  name="tipo"
                  value={formData.tipo}
                  onChange={handleInputChange}
                  select
                  required
                  error={formErrors.tipo}
                  helperText={formErrors.tipo ? "Tipo é obrigatório" : ""}
                >
                  <MenuItem value="sala">Sala</MenuItem>
                  <MenuItem value="presencial">Presencial</MenuItem>
                  <MenuItem value="online">Online</MenuItem>
                </TextField>
                <TextField
                  fullWidth
                  label="Capacidade"
                  name="capacidade"
                  type="number"
                  value={formData.capacidade}
                  onChange={handleInputChange}
                  required
                  error={formErrors.capacidade}
                  helperText={formErrors.capacidade ? "Capacidade é obrigatória" : ""}
                />
              </Box>
              <TextField
                fullWidth
                label="Descrição"
                name="descricao"
                value={formData.descricao}
                onChange={handleInputChange}
                multiline
                rows={4}
              />
              <Box sx={{ display: 'flex', gap: 2 }}>
                <TextField
                  fullWidth
                  label="Andar"
                  name="andar"
                  value={formData.andar}
                  onChange={handleInputChange}
                />
                <TextField
                  fullWidth
                  label="Bloco"
                  name="bloco"
                  value={formData.bloco}
                  onChange={handleInputChange}
                />
              </Box>
              <FormControlLabel
                control={
                  <Switch
                    checked={formData.ativo}
                    onChange={(e) => setFormData(prev => ({ ...prev, ativo: e.target.checked }))}
                  />
                }
                label="Ativo"
              />
            </Box>
          )}

          {activeTabForm === 1 && (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <TextField
                fullWidth
                label="CEP"
                name="cep"
                value={formData.cep || ''}
                onChange={handleInputChange}
                onBlur={handleBlur}
                placeholder="00000-000"
                inputProps={{
                  maxLength: 9
                }}
              />
              <TextField
                fullWidth
                label="Endereço"
                name="endereco"
                value={formData.endereco || ''}
                onChange={handleInputChange}
              />
              <Box sx={{ display: 'flex', gap: 2 }}>
                <TextField
                  fullWidth
                  label="Cidade"
                  name="cidade"
                  value={formData.cidade || ''}
                  onChange={handleInputChange}
                />
                <TextField
                  fullWidth
                  label="Estado"
                  name="estado"
                  value={formData.estado || ''}
                  onChange={handleInputChange}
                />
              </Box>
            </Box>
          )}

          {activeTabForm === 2 && (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <Box sx={{ display: 'flex', gap: 2 }}>
                <TextField
                  fullWidth
                  label="Telefone"
                  name="telefone"
                  value={formData.telefone || ''}
                  onChange={handleInputChange}
                  placeholder="(00) 00000-0000"
                  inputProps={{
                    maxLength: 15
                  }}
                />
                <TextField
                  fullWidth
                  label="Email"
                  name="email"
                  value={formData.email || ''}
                  onChange={handleInputChange}
                />
              </Box>
            </Box>
          )}

          {activeTabForm === 3 && (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <Typography variant="subtitle1">Equipamentos</Typography>
              <TextField
                fullWidth
                label="Equipamentos"
                name="equipamentosMedicos"
                value={formData.equipamentosMedicos?.join(', ') || ''}
                onChange={(e) => setFormData(prev => ({
                  ...prev,
                  equipamentosMedicos: e.target.value.split(',').map(item => item.trim())
                }))}
                multiline
                rows={4}
                helperText="Digite os equipamentos separados por vírgula"
              />
              <Typography variant="subtitle1">Serviços oferecidos no local</Typography>
              <TextField
                fullWidth
                label="Serviços oferecidos no local"
                name="especialidadesAtendidas"
                value={formData.especialidadesAtendidas?.join(', ') || ''}
                onChange={(e) => setFormData(prev => ({
                  ...prev,
                  especialidadesAtendidas: e.target.value.split(',').map(item => item.trim())
                }))}
                multiline
                rows={4}
                helperText="Digite os serviços separados por vírgula"
              />
            </Box>
          )}

        </DialogContent>

        <DialogActions sx={{ 
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          padding: 2,
          backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1B5E20' : '#E0F8E0',
          borderTop: 1,
          borderColor: 'divider',
          zIndex: 1,
          height: '60px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          '& .MuiButton-root': {
            fontSize: '0.875rem',
            textTransform: 'uppercase',
            fontWeight: 500
          },
          '& .MuiTypography-root': {
            fontSize: '0.875rem'
          }
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Typography variant="body2" color="text.secondary">
            {formatarDataHora(dataHoraAtual)}
          </Typography>
          </Box>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button
              variant="outlined"
              onClick={() => setActiveTabForm(prev => Math.max(0, prev - 1))}
              disabled={activeTabForm === 0}
            >
              Anterior
            </Button>
            <Button
              variant="outlined"
              onClick={() => setActiveTabForm(prev => Math.min(3, prev + 1))}
              disabled={activeTabForm === 3}
            >
              Próximo
            </Button>

            <Button
              variant="contained"
              color="primary"
              onClick={fecharFormulario}
            >
              FECHAR
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={salvarLocal}
              disabled={loading}
            >
              {loading ? <CircularProgress size={24} /> : "SALVAR"}
            </Button>
          </Box>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openView}
        onClose={fecharVisualizacao}
        maxWidth={false}
        fullWidth={false}
        disableEscapeKeyDown
        disableBackdropClick
        disablePortal
        hideBackdrop={false}
        sx={{
          '& .MuiDialog-backdrop': {
            backgroundColor: 'rgba(0, 0, 0, 0.8)'
          }
        }}
        PaperProps={{
          sx: {
            width: '950px',
            height: '600px',
            position: 'relative'
          }
        }}
      >
        <DialogTitle sx={{ 
          backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1B5E20' : '#E0F8E0',
          borderBottom: 1,
          borderColor: 'divider',
          padding: 2,
          position: 'sticky',
          top: 0,
          zIndex: 1,
          fontSize: '1.25rem',
          fontWeight: 500
        }}>
          Visualizar Local
        </DialogTitle>
        <DialogContent sx={{ 
          height: 'calc(100% - 140px)',
          overflow: 'auto',
          padding: 2,
          position: 'relative',
          top: 0,
          marginBottom: '60px',
          '& .MuiInputLabel-root': {
            fontSize: '0.875rem'
          },
          '& .MuiInputBase-input': {
            fontSize: '0.875rem'
          },
          '& .MuiFormControlLabel-label': {
            fontSize: '0.875rem'
          }
        }}>
          {localVisualizar ? (
            <>
                <Tabs 
                  value={activeTabView} 
                  onChange={(e, newValue) => setActiveTabView(newValue)}
                sx={{
                  borderBottom: 1,
                  borderColor: 'divider',
                  mb: 2
                }}
                >
                  <Tab label="Dados Básicos" />
                <Tab label="Endereço" />
                <Tab label="Contato" />
                <Tab label="Especificações" />
                </Tabs>

              {activeTabView === 0 && (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                  <TextField 
                    label="Nome" 
                    value={localVisualizar.nome || ''} 
                    fullWidth 
                    InputProps={{ readOnly: true }}
                    sx={{
                      '& .MuiInputBase-input': {
                        color: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)',
                        WebkitTextFillColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)'
                      },
                      '& .MuiInputLabel-root': {
                        color: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)'
                      }
                    }}
                  />
                  <Box sx={{ display: 'flex', gap: 2 }}>
                    <TextField 
                      label="Tipo" 
                      value={localVisualizar.tipo || ''} 
                      fullWidth 
                      InputProps={{ readOnly: true }}
                      sx={{
                        '& .MuiInputBase-input': {
                          color: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)',
                          WebkitTextFillColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)'
                        },
                        '& .MuiInputLabel-root': {
                          color: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)'
                        }
                      }}
                    />
                    <TextField 
                      label="Capacidade" 
                      value={localVisualizar.capacidade || ''} 
                      fullWidth 
                      InputProps={{ readOnly: true }}
                      sx={{
                        '& .MuiInputBase-input': {
                          color: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)',
                          WebkitTextFillColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)'
                        },
                        '& .MuiInputLabel-root': {
                          color: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)'
                        }
                      }}
                    />
                  </Box>
                  <TextField 
                    label="Descrição" 
                    value={localVisualizar.descricao || ''} 
                    fullWidth 
                    multiline 
                    rows={4} 
                    InputProps={{ readOnly: true }}
                    sx={{
                      '& .MuiInputBase-input': {
                        color: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)',
                        WebkitTextFillColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)'
                      },
                      '& .MuiInputLabel-root': {
                        color: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)'
                      }
                    }}
                  />
                  <Box sx={{ display: 'flex', gap: 2 }}>
                    <TextField 
                      label="Andar" 
                      value={localVisualizar.andar || ''} 
                      fullWidth 
                      InputProps={{ readOnly: true }}
                      sx={{
                        '& .MuiInputBase-input': {
                          color: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)',
                          WebkitTextFillColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)'
                        },
                        '& .MuiInputLabel-root': {
                          color: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)'
                        }
                      }}
                    />
                    <TextField 
                      label="Bloco" 
                      value={localVisualizar.bloco || ''} 
                      fullWidth 
                      InputProps={{ readOnly: true }}
                      sx={{
                        '& .MuiInputBase-input': {
                          color: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)',
                          WebkitTextFillColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)'
                        },
                        '& .MuiInputLabel-root': {
                          color: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)'
                        }
                      }}
                    />
                  </Box>
                  <FormControlLabel 
                    control={
                      <Switch 
                        checked={!!localVisualizar.ativo} 
                        disabled
                        sx={{
                          '& .MuiSwitch-switchBase.Mui-disabled': {
                            color: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.3)' : 'rgba(0, 0, 0, 0.3)'
                          },
                          '& .MuiSwitch-track.Mui-disabled': {
                            backgroundColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)'
                          }
                        }}
                      />
                    } 
                    label="Ativo"
                    sx={{
                      '& .MuiFormControlLabel-label': {
                        color: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)'
                      }
                    }}
                  />
                </Box>
              )}

              {activeTabView === 1 && (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                  <TextField
                    label="CEP"
                    value={localVisualizar.cep || ''}
                    fullWidth
                    InputProps={{ readOnly: true }}
                    sx={{
                      '& .MuiInputBase-input': {
                        color: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)',
                        WebkitTextFillColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)'
                      },
                      '& .MuiInputLabel-root': {
                        color: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)'
                      }
                    }}
                  />
                  <TextField
                    label="Endereço"
                    value={localVisualizar.endereco || ''}
                    fullWidth
                    InputProps={{ readOnly: true }}
                    sx={{
                      '& .MuiInputBase-input': {
                        color: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)',
                        WebkitTextFillColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)'
                      },
                      '& .MuiInputLabel-root': {
                        color: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)'
                      }
                    }}
                  />
                  <Box sx={{ display: 'flex', gap: 2 }}>
                    <TextField
                      label="Cidade"
                      value={localVisualizar.cidade || ''}
                      fullWidth
                      InputProps={{ readOnly: true }}
                      sx={{
                        '& .MuiInputBase-input': {
                          color: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)',
                          WebkitTextFillColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)'
                        },
                        '& .MuiInputLabel-root': {
                          color: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)'
                        }
                      }}
                    />
                    <TextField
                      label="Estado"
                      value={localVisualizar.estado || ''}
                      fullWidth
                      InputProps={{ readOnly: true }}
                      sx={{
                        '& .MuiInputBase-input': {
                          color: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)',
                          WebkitTextFillColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)'
                        },
                        '& .MuiInputLabel-root': {
                          color: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)'
                        }
                      }}
                    />
                  </Box>
                </Box>
              )}

              {activeTabView === 2 && (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                  <Box sx={{ display: 'flex', gap: 2 }}>
                    <TextField
                      label="Telefone"
                      value={localVisualizar.telefone || ''}
                      fullWidth
                      InputProps={{ readOnly: true }}
                      sx={{
                        '& .MuiInputBase-input': {
                          color: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)',
                          WebkitTextFillColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)'
                        },
                        '& .MuiInputLabel-root': {
                          color: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)'
                        }
                      }}
                    />
                    <TextField
                      label="Email"
                      value={localVisualizar.email || ''}
                      fullWidth
                      InputProps={{ readOnly: true }}
                      sx={{
                        '& .MuiInputBase-input': {
                          color: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)',
                          WebkitTextFillColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)'
                        },
                        '& .MuiInputLabel-root': {
                          color: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)'
                        }
                      }}
                    />
                  </Box>
                </Box>
              )}

              {activeTabView === 3 && (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                  <FormControlLabel 
                    control={
                      <Switch 
                        checked={!!localVisualizar.ativo} 
                        disabled
                        sx={{
                          '& .MuiSwitch-switchBase.Mui-disabled': {
                            color: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.3)' : 'rgba(0, 0, 0, 0.3)'
                          },
                          '& .MuiSwitch-track.Mui-disabled': {
                            backgroundColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)'
                          }
                        }}
                      />
                    } 
                    label="Ativo"
                    sx={{
                      '& .MuiFormControlLabel-label': {
                        color: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)'
                      }
                    }}
                  />
                  <TextField 
                    label="Equipamentos" 
                    value={localVisualizar.equipamentosMedicos?.join(', ') || ''} 
                    fullWidth 
                    multiline 
                    rows={4} 
                    InputProps={{ readOnly: true }}
                    sx={{
                      '& .MuiInputBase-input': {
                        color: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)',
                        WebkitTextFillColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)'
                      },
                      '& .MuiInputLabel-root': {
                        color: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)'
                      }
                    }}
                  />
                  <TextField 
                    label="Serviços oferecidos no local" 
                    value={localVisualizar.especialidadesAtendidas?.join(', ') || ''} 
                    fullWidth 
                    multiline 
                    rows={4} 
                    InputProps={{ readOnly: true }}
                    sx={{
                      '& .MuiInputBase-input': {
                        color: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)',
                        WebkitTextFillColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)'
                      },
                      '& .MuiInputLabel-root': {
                        color: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)'
                      }
                    }}
                  />
                  <TextField 
                    label="Data de Criação" 
                    value={formatarDataHora(localVisualizar.ts_created)} 
                    fullWidth 
                    InputProps={{ readOnly: true }}
                    sx={{
                      '& .MuiInputBase-input': {
                        color: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)',
                        WebkitTextFillColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)'
                      },
                      '& .MuiInputLabel-root': {
                        color: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)'
                      }
                    }}
                  />
                  <TextField 
                    label="Última Atualização" 
                    value={formatarDataHora(localVisualizar.ts_updated)} 
                    fullWidth 
                    InputProps={{ readOnly: true }}
                    sx={{
                      '& .MuiInputBase-input': {
                        color: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)',
                        WebkitTextFillColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)'
                      },
                      '& .MuiInputLabel-root': {
                        color: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)'
                      }
                    }}
                  />
                </Box>
              )}
            </>
          ) : (
            <Typography>Carregando...</Typography>
          )}
        </DialogContent>
        <DialogActions sx={{ 
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          padding: 2,
          backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1B5E20' : '#E0F8E0',
          borderTop: 1,
          borderColor: 'divider',
          zIndex: 1,
          height: '60px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          '& .MuiButton-root': {
            fontSize: '0.875rem',
            textTransform: 'uppercase',
            fontWeight: 500
          },
          '& .MuiTypography-root': {
            fontSize: '0.875rem'
          }
        }}>
          <Typography variant="body2" color="text.secondary">
            {formatarDataHora(dataHoraAtual)}
          </Typography>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button 
              variant="contained" 
              color="primary"
              onClick={() => setActiveTabView(prev => Math.max(0, prev - 1))}
              disabled={activeTabView === 0}
            >
              ANTERIOR
            </Button>
            <Button 
              variant="contained" 
              color="primary"
              onClick={() => setActiveTabView(prev => Math.min(3, prev + 1))}
              disabled={activeTabView === 3}
            >
              PRÓXIMO
            </Button>
            <Button 
              variant="contained" 
              color="primary"
              onClick={fecharVisualizacao}
            >
              FECHAR
            </Button>
          </Box>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openDeleteConfirm}
        onClose={() => setOpenDeleteConfirm(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ 
          backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#d32f2f' : '#ffebee',
          borderBottom: 1,
          borderColor: 'divider',
          padding: 2,
          color: (theme) => theme.palette.mode === 'dark' ? '#ffcdd2' : '#c62828',
          fontSize: '1.25rem',
          fontWeight: 500
        }}>
          Confirmar Exclusão
        </DialogTitle>
        <DialogContent sx={{ padding: 2 }}>
          <Typography>
            Tem certeza que deseja excluir este local?
          </Typography>
        </DialogContent>
        <DialogActions sx={{ 
          backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1B5E20' : '#E0F8E0',
          borderTop: 1,
          borderColor: 'divider',
          padding: 2,
          '& .MuiButton-root': {
            fontSize: '0.875rem',
            textTransform: 'uppercase',
            fontWeight: 500
          }
        }}>
          <Button onClick={() => setOpenDeleteConfirm(false)}>CANCELAR</Button>
          <Button 
            variant="contained" 
            color="error" 
            onClick={excluirLocal} 
            disabled={loading}
          >
            EXCLUIR
          </Button>
        </DialogActions>
      </Dialog>
      </Box>
    </AcessoRestrito>
  );
}